<template>
    <div
        :class="[$style.preloader, { [$style.clickable]: hasError }]"
        @click="handleClose"
    >
        <ErrorState
            v-if="hasError"
            :adType
        />
        <Progress
            v-else
            :isPortal
        />
    </div>
</template>

<script lang="ts" setup>
import { OutOfPageAdType } from '@/modules/adv'

import ErrorState from './ErrorState.vue'
import Progress from './Progress.vue'

interface Props {
    hasError: boolean
    isPortal: boolean
    adType: OutOfPageAdType | null
}

const props = defineProps<Props>()

const emit = defineEmits<{
    close: []
}>()

function handleClose() {
    if (props.hasError) {
        emit('close')
    }
}
</script>

<style module>
.preloader {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: rgba(0, 0, 0, 0.9);
    display: flex;
    align-items: center;
    justify-content: center;
}

.clickable {
    cursor: pointer;
}
</style>
